import { makeStyles } from "@material-ui/styles";
import color from "context/MaterialUITheme/color";

const useStyles = makeStyles(() => ({
  authCodeInput: {
    width: "3.4rem",
    height: "3.6rem",
    color: color.purple,
    fontSize: "24px",
    textAlign: "center",
    borderRadius: "0.5rem",
    border: "1px solid #d6d6d6",
    fontFamily: "Pro Display Regular",
    "@media only screen and (max-width: 600px)": {
      width: "1rem",
      height: "2rem",
    },
  },
  authCodeContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default useStyles;
